/* eslint-env browser */
/**
 * Browser shim for Node's `process`. Some dependencies (e.g. html2pdf / core-js paths)
 * reference `process` or `process.nextTick` when bundled for the web.
 */
(function installProcessShim() {
  var nextTick = function (fn, a, b, c) {
    if (typeof fn !== 'function') return;
    Promise.resolve().then(function () {
      fn(a, b, c);
    });
  };

  function ensureProcess(target) {
    if (!target || typeof target !== 'object') return;
    if (typeof target.process === 'undefined') {
      target.process = {
        env: {},
        browser: true,
        nextTick: nextTick,
        versions: {}
      };
      return;
    }
    var p = target.process;
    if (!p.env) p.env = {};
    if (typeof p.nextTick !== 'function') p.nextTick = nextTick;
    if (!p.versions) p.versions = {};
  }

  // CRA runs in the browser; `window` is enough (avoids `globalThis` / `self` ESLint issues).
  if (typeof window !== 'undefined') {
    ensureProcess(window);
  }
})();
